import Input from './input';

export { default as Input } from './input';

export default { Input };
